import { useEffect } from "react";

// App Bridge v4 note: Fullscreen API was removed in App Bridge v4
// Fullscreen mode is now handled automatically by the Shopify admin
// This hook is kept for backwards compatibility but does nothing
export default function useFullscreen() {
  return useEffect(() => {
    // No-op in App Bridge v4
    console.log("[useFullscreen] Fullscreen mode is handled automatically in App Bridge v4");
  }, []);
}
